'use client';

import React, { type CSSProperties } from 'react';

import { Heading, Body } from '@depop/web-thrift-ui/Typography';
import { useResponsive } from '@depop/web-ui-kit/useResponsive';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';

export type BubbleItem = {
  url: string;
  imgSrc?: string;
  imgAlt?: string;
  label?: string;
};

type Props = {
  items: BubbleItem[];
  title?: string;
  onBubbleClick?: (item: BubbleItem, index: number) => void;
};

export function BubbleNavigation({
  items,
  title,
  onBubbleClick = () => null,
}: Props) {
  const { isMaxMedium: isMobile } = useResponsive();

  function getGridSettings(itemCount: number): {
    columnSize: string;
    columns: number;
  } {
    if (isMobile) {
      return itemCount < 3
        ? { columnSize: 'minmax(80px, 100px)', columns: itemCount }
        : { columnSize: '1fr', columns: 3 };
    }

    return itemCount < 6
      ? { columnSize: 'minmax(100px, 200px)', columns: itemCount }
      : { columnSize: '1fr', columns: 6 };
  }

  const { columnSize, columns } = getGridSettings(items.length);

  return (
    <div>
      {title && (
        <Heading variant="md" className={styles.title}>
          {title}
        </Heading>
      )}
      <div
        className={styles.container}
        style={
          {
            '--column': columns,
            '--column-size': columnSize,
          } as CSSProperties
        }
      >
        {items.map((item, index) => {
          const { label, imgSrc, url, imgAlt } = item;
          return (
            <ExtendedLink
              href={url}
              key={label}
              onClick={() => onBubbleClick(item, index)}
            >
              {imgSrc && (
                <img src={imgSrc} alt={imgAlt} className={styles.image} />
              )}
              {label && (
                <Body variant="sm-bold" className={styles.label}>
                  {label}
                </Body>
              )}
            </ExtendedLink>
          );
        })}
      </div>
    </div>
  );
}
